<section class="container product-page py-4">
  @if (loading()) {
    <p class="text-body-secondary">Cargando producto...</p>
  } @else if (device(); as product) {
    <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
      <nav aria-label="Miga de pan">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item"><a routerLink="/portal/home">Inicio</a></li>
          <li class="breadcrumb-item"><a routerLink="/portal/home">Productos</a></li>
          <li class="breadcrumb-item active text-truncate" aria-current="page">{{ product.fdName }}</li>
        </ol>
      </nav>
      <a class="back-link flex-shrink-0" routerLink="/portal/home"><i class="bi bi-chevron-left"></i> Volver a productos</a>
    </div>
    <div class="d-flex align-items-center justify-content-between gap-3 mb-4">
      <h1 class="h3 mb-0">{{ product.fdName }}</h1>
      <div class="d-flex align-items-center gap-2 flex-shrink-0">
        <div class="product-rating-summary text-end" [attr.aria-label]="deviceRating().averageRating + ' de 5 estrellas, ' + deviceRating().opinionCount + ' opiniones'">
          <span class="fw-semibold me-1">{{ formatAverageRating(deviceRating().averageRating) }}</span>
          <span class="comment-rating me-1">@for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= deviceRating().averageRating" [class.bi-star]="star > deviceRating().averageRating"></i> }</span>
          <small class="text-body-secondary">({{ deviceRating().opinionCount }})</small>
        </div>
        <button class="btn btn-outline-primary" type="button" (click)="openComments()"><i class="bi bi-chat-left-text me-1"></i>Comentarios</button>
      </div>
    </div>

    <div class="row g-4 align-items-stretch">
      <div class="col-12 col-lg-3">
        <div class="card gallery-card h-100">
          <div class="card-header">Imágenes</div>
          <div class="card-body gallery-scroll p-2">
            @for (image of images(); track image.id) {
              <button class="thumbnail-card" type="button" [class.active]="mainImage() === image.source" (click)="selectImage(image)">
                <img [src]="image.source" alt="Imagen de {{ product.fdName }}" />
              </button>
            }
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="card main-image-card h-100">
          <div class="card-body d-flex align-items-center justify-content-center p-3">
            @if (mainImage()) {
              <button class="main-image-button" type="button" (click)="openImageModal()" aria-label="Ampliar imagen">
                <img class="main-image" [src]="mainImage()" [alt]="product.fdName" />
              </button>
            } @else {
              <span class="text-body-secondary">No hay imagen disponible.</span>
            }
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card purchase-card h-100">
          <div class="card-header">Compra</div>
          <div class="card-body d-flex flex-column">
            <div class="alert alert-info display-6 fw-semibold text-center" [class.text-decoration-line-through]="hasDiscount(product)" [class.text-body-secondary]="hasDiscount(product)" [class.mb-2]="hasDiscount(product)" [class.mb-4]="!hasDiscount(product)">{{ formatPrice(product.fdPrice) }}</div>
            @if (hasDiscount(product)) {
              <div class="alert alert-danger display-6 fw-semibold text-center mb-4">
                {{ formatPrice(discountedPrice(product)) }}
                <span class="badge text-bg-danger align-middle ms-1">-{{ product.fdDto }}%</span>
              </div>
            }
            <div class="alert alert-info text-center mb-4">Stock disponible: <strong>{{ product.fdStock }}</strong></div>
            <div class="purchase-actions mt-auto d-flex gap-3 align-items-end">
              <div class="quantity-control">
                <label class="form-label small mb-1" for="quantity">Cantidad</label>
                <input
                  id="quantity"
                  class="form-control"
                  type="number"
                  min="1"
                  [max]="product.fdStock"
                  [value]="quantity()"
                  [disabled]="product.fdStock < 1"
                  (input)="setQuantity($any($event.target).value, product.fdStock)"
                />
              </div>
              <button class="btn btn-primary flex-grow-1" type="button" [disabled]="product.fdStock < 1">Agregar al carrito</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4 mt-1">
      <div class="col-12 col-lg-6">
        <div class="card h-100"><div class="card-header">Características</div><div class="card-body p-0">
          <table class="table table-sm mb-0 detail-table"><tbody>
            <tr><th>Código</th><td>{{ product.fdCode }}</td></tr>
            <tr><th>Nombre</th><td>{{ product.fdName }}</td></tr>
            <tr><th>Memoria RAM</th><td>{{ product.fdRam }}</td></tr>
            <tr><th>Almacenamiento</th><td>{{ product.fdStorage }}</td></tr>
            <tr><th>Tamaño de la pantalla</th><td>{{ product.fdScreenSize }}</td></tr>
          </tbody></table>
        </div></div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="card h-100"><div class="card-header">Especificaciones</div><div class="card-body p-0">
          <table class="table table-sm mb-0 detail-table"><tbody>
            <tr><th>Fecha de lanzamiento</th><td>{{ formatDate(product.fdRelease) }}</td><td></td></tr>
            <tr>
              <th>Marca del dispositivo</th><td>{{ product.brandName }}</td>
              <td class="related-image-cell">@if (product.brandImage) { <img class="related-image" [src]="relatedImageSource(product.brandImage)" [alt]="product.brandName" /> } @else { <i class="bi bi-bookmark-star text-body-secondary"></i> }</td>
            </tr>
            <tr>
              <th>Tarjeta gráfica</th><td>{{ product.graphicCardName }}</td>
              <td class="related-image-cell">@if (product.graphicCardImage) { <img class="related-image" [src]="relatedImageSource(product.graphicCardImage)" [alt]="product.graphicCardName" /> } @else { <i class="bi bi-gpu-card text-body-secondary"></i> }</td>
            </tr>
            <tr>
              <th>Sistema operativo</th><td>{{ product.operatingSystemName }}</td>
              <td class="related-image-cell">@if (product.operatingSystemImage) { <img class="related-image" [src]="relatedImageSource(product.operatingSystemImage)" [alt]="product.operatingSystemName" /> } @else { <i class="bi bi-windows text-body-secondary"></i> }</td>
            </tr>
            <tr>
              <th>Tipo de procesador</th><td>{{ product.processorName }}</td>
              <td class="related-image-cell">@if (product.processorImage) { <img class="related-image" [src]="relatedImageSource(product.processorImage)" [alt]="product.processorName" /> } @else { <i class="bi bi-cpu text-body-secondary"></i> }</td>
            </tr>
          </tbody></table>
        </div></div>
      </div>
      <div class="col-12">
        <div class="card"><div class="card-header">Detalle</div><div class="card-body detail-text">{{ product.fdDetail || 'Sin detalle disponible.' }}</div></div>
      </div>
      @if (relatedProducts().length) {
        <div class="col-12">
          <section class="card recommendations-card">
            <div class="card-header">Otros también vieron</div>
            <div class="card-body p-3">
              <div class="recommendations-scroll">
                @for (relatedProduct of relatedProducts(); track relatedProduct.id) {
                  <a class="card recommendation-item text-reset text-decoration-none" [class.border-danger]="hasRecommendationDiscount(relatedProduct)" [class.border-2]="hasRecommendationDiscount(relatedProduct)" [routerLink]="['/portal/product', relatedProduct.id]">
                    <div class="card-body d-flex flex-column">
                      <img class="recommendation-image mb-3" [src]="relatedProduct.image" [alt]="relatedProduct.name" />
                      <h2 class="h6 recommendation-name">{{ relatedProduct.name }}</h2>
                      <span class="fw-semibold mt-auto" [class.text-decoration-line-through]="hasRecommendationDiscount(relatedProduct)" [class.text-body-secondary]="hasRecommendationDiscount(relatedProduct)" [class.text-primary]="!hasRecommendationDiscount(relatedProduct)">{{ formatPrice(relatedProduct.price) }}</span>
                      @if (hasRecommendationDiscount(relatedProduct)) {
                        <span class="text-danger fw-semibold">{{ formatPrice(discountedRecommendationPrice(relatedProduct)) }} <span class="badge text-bg-danger">-{{ relatedProduct.discount }}%</span></span>
                      }
                    </div>
                  </a>
                }
              </div>
            </div>
          </section>
        </div>
      }
    </div>
  } @else {
    <div class="alert alert-warning mb-0">El producto solicitado no está disponible.</div>
  }
</section>

@if (showImageModal()) {
  <div class="modal d-block image-modal" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true" (click)="closeImageModal()">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-body p-3">
          <div class="row g-3">
            <div class="col-12 text-center">
              <div class="card modal-main-image-card">
                <div class="card-body text-center">
                  <img class="modal-product-image img-fluid" [src]="mainImage()" alt="Imagen ampliada del producto" />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card modal-gallery-card">
                <div class="card-header py-2">Más imágenes</div>
                <div class="card-body modal-gallery-list p-2">
                  @for (image of images(); track image.id) {
                    <button class="modal-thumbnail" type="button" [class.active]="mainImage() === image.source" (click)="selectImage(image)">
                      <img [src]="image.source" alt="Seleccionar imagen del producto" />
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}

@if (commentsModalOpen()) {
  <div class="modal d-block comments-modal" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true" aria-label="Comentarios del producto">
    <div class="modal-dialog modal-dialog-scrollable comments-modal-dialog" role="document">
      <div class="modal-content h-100">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title fs-5 mb-0">{{ commentFormOpen() ? 'Escribir opinión' : 'Comentarios' }}</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeComments()"></button>
        </div>
        <div class="modal-body">
          @if (commentFormOpen()) {
            <p class="fw-semibold mb-3">{{ device()?.fdName }}</p>
            <form id="comment-form" class="comment-form" [formGroup]="commentForm" (ngSubmit)="submitComment()">
              <div class="mb-3">
                <label class="form-label" for="fdRating">Calificación <span class="text-danger">*</span></label>
                <div id="fdRating" class="rating-input" role="radiogroup" aria-label="Calificación">
                  @for (rating of ratingStars; track rating) {
                    <button class="rating-star" type="button" [class.active]="rating <= commentForm.controls.fdRating.value" [attr.aria-label]="rating + ' estrellas'" (click)="setCommentRating(rating)">
                      <i class="bi" [class.bi-star-fill]="rating <= commentForm.controls.fdRating.value" [class.bi-star]="rating > commentForm.controls.fdRating.value"></i>
                    </button>
                  }
                  <span class="small text-body-secondary ms-2">{{ commentForm.controls.fdRating.value }} de 5</span>
                </div>
              </div>
              <div class="comment-content-group mb-0">
                <label class="form-label" for="fdContent">Opinión <span class="text-danger">*</span></label>
                <textarea id="fdContent" class="form-control" rows="7" maxlength="2000" formControlName="fdContent" placeholder="Escriba su opinión sobre el producto..."></textarea>
                @if (commentForm.controls.fdContent.touched && commentForm.controls.fdContent.invalid) { <div class="invalid-feedback d-block">La opinión es obligatoria.</div> }
              </div>
            </form>
          } @else {
            <p class="fw-semibold mb-3">{{ device()?.fdName }}</p>
            @if (commentsLoading()) {
              <p class="text-body-secondary mb-0">Cargando comentarios...</p>
            } @else {
              <div class="row g-2 rating-summary mb-3">
                <div class="col-12 col-sm-5">
                  <section class="card h-100 rating-score-card"><div class="card-body text-center py-3">
                    <div class="display-5 fw-semibold">{{ formatAverageRating(deviceRating().averageRating) }}</div>
                    <div class="comment-rating my-1" [attr.aria-label]="deviceRating().averageRating + ' de 5 estrellas'">
                      @for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= deviceRating().averageRating" [class.bi-star]="star > deviceRating().averageRating"></i> }
                    </div>
                    <small class="text-body-secondary">{{ deviceRating().opinionCount }} {{ deviceRating().opinionCount === 1 ? 'opinión' : 'opiniones' }}</small>
                  </div></section>
                </div>
                <div class="col-12 col-sm-7">
                  <section class="card h-100 rating-distribution-card"><div class="card-body py-3">
                    @for (rating of ratingLevels; track rating) {
                      <div class="rating-distribution-row">
                        <span class="rating-distribution-label">{{ rating }} <i class="bi bi-star-fill"></i></span>
                        <div class="progress" role="progressbar" [attr.aria-label]="rating + ' estrellas'" [attr.aria-valuenow]="ratingPercentage(rating)" aria-valuemin="0" aria-valuemax="100"><div class="progress-bar bg-warning" [style.width.%]="ratingPercentage(rating)"></div></div>
                        <span class="rating-distribution-count">{{ ratingCount(rating) }}</span>
                      </div>
                    }
                  </div></section>
                </div>
              </div>
              <div class="comments-list">
                @for (comment of productComments(); track comment.idRegister) {
                  <article class="comment-item">
                    <div class="row g-2 mb-2">
                      <div class="col-12"><h3 class="h6 mb-0"><i class="bi bi-person-circle me-1"></i>{{ comment.userName }}</h3></div>
                      <div class="col-6"><span class="comment-rating" [attr.aria-label]="comment.fdRating + ' de 5 estrellas'">@for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= comment.fdRating" [class.bi-star]="star > comment.fdRating"></i> }</span></div>
                      <div class="col-6 text-end"><small class="text-body-secondary">{{ formatCommentDate(comment) }}</small></div>
                    </div>
                    <p class="mb-0 comment-content">{{ comment.fdContent }}</p>
                  </article>
                } @empty {
                  <p class="text-body-secondary mb-0">Este producto aún no tiene comentarios.</p>
                }
              </div>
            }
          }
        </div>
        <div class="modal-footer">
          @if (commentFormOpen()) {
            <button class="btn btn-outline-secondary" type="button" [disabled]="commentSubmitting()" (click)="cancelCommentForm()">Volver</button>
            <button class="btn btn-primary" type="submit" form="comment-form" [disabled]="commentSubmitting()">
              @if (commentSubmitting()) { <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Publicando... } @else { Publicar opinión }
            </button>
          } @else {
            <button class="btn btn-outline-secondary" type="button" (click)="closeComments()">Cerrar</button>
            <div>
              <button class="btn btn-primary" type="button" [disabled]="!authSession.isAuthenticated() || commentAuthorLoading()" (click)="openCommentForm()">
                @if (commentAuthorLoading()) { <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Preparando... } @else { Escribir opinión }
              </button>
              @if (!authSession.isAuthenticated()) { <small class="d-block text-body-secondary mt-1">Inicie sesión para escribir una opinión.</small> }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}
